/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;
exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _iconography = require("../iconography");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.uniqueid"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Checkbox = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Checkbox, _React$Component);

  function Checkbox() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Checkbox.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.el.indeterminate = this.props.indeterminate;

    require('../../css/forms');

    require('../../css/checkbox');
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.indeterminate !== this.props.indeterminate) {
      this.el.indeterminate = this.props.indeterminate;
    }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        noSelect = _this$props.noSelect,
        indeterminate = _this$props.indeterminate,
        className = _this$props.className,
        disabled = _this$props.disabled,
        children = _this$props.children,
        labelClassName = _this$props.labelClassName,
        style = _this$props.style,
        _this$props$id = _this$props.id,
        id = _this$props$id === void 0 ? (0, _lodash["default"])('checkbox') : _this$props$id,
        others = _objectWithoutPropertiesLoose(_this$props, ["noSelect", "indeterminate", "className", "disabled", "children", "labelClassName", "style", "id"]);

    return _react["default"].createElement("div", {
      className: (0, _classnames["default"])('pui-checkbox', className),
      style: style
    }, _react["default"].createElement("input", _extends({}, others, {
      className: 'pui-checkbox-input',
      type: 'checkbox',
      id: id,
      disabled: disabled,
      ref: function ref(el) {
        return _this.el = el;
      },
      'aria-disabled': disabled
    })), _react["default"].createElement("label", {
      className: (0, _classnames["default"])('pui-checkbox-label', labelClassName, {
        'pui-no-select': noSelect
      }),
      htmlFor: id
    }, _react["default"].createElement("span", {
      className: "pui-checkbox-control"
    }, _react["default"].createElement(_iconography.Icon, {
      src: indeterminate ? 'remove' : 'check'
    })), children));
  };

  return Checkbox;
}(_react["default"].Component);

exports.Checkbox = Checkbox;

_defineProperty(Checkbox, "propTypes", {
  checked: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  defaultChecked: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  id: _propTypes["default"].string,
  indeterminate: _propTypes["default"].bool,
  labelClassName: _propTypes["default"].string,
  name: _propTypes["default"].string,
  noSelect: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  style: _propTypes["default"].object,
  type: _propTypes["default"].string
});

_defineProperty(Checkbox, "defaultProps", {
  indeterminate: false,
  type: 'checkbox'
});